export class PromoModel {
  constructor(data: any) {
    this.id = data.id;
    this.type = data.type;
    this.expires = data.expires;
    this.status = data.status;
    if (this.expires < new Date().getTime()) this.status = false;
  }

  id: string;
  type: string;
  expires: number;
  status: boolean;
}
